import styles from './Badge.module.scss';

export interface BadgeProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLSpanElement>,
      HTMLSpanElement
    >,
    'prefix'
  > {
  color?:
    | 'neutralPrimary'
    | 'neutralSecondary'
    | 'warning'
    | 'warningSecondary'
    | 'positive'
    | 'positiveSecondary'
    | 'negative'
    | 'negativeSecondary'
    | 'action'
    | 'actionSecondary'
    | 'premium';
  text?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  testId: string;
}

export const Badge = ({
  color = 'neutralPrimary',
  text,
  prefix,
  suffix,
  className,
  testId,
  ...props
}: BadgeProps) => {
  return (
    <span
      {...props}
      className={`${styles.badge} ${className || ''}`}
      data-color={color}
      data-test-id={`${testId}-container-${color}`}
    >
      {prefix && (
        <div className={styles.prefix} data-test-id="badge-prefix">
          {prefix}
        </div>
      )}
      {text && (
        <div className={styles.text} data-test-id="badge-text">
          {text}
        </div>
      )}
      {suffix && (
        <div className={styles.suffix} data-test-id="badge-suffix">
          {suffix}
        </div>
      )}
    </span>
  );
};
